const KEY = "paws.theme";
const MODES = ["system", "light", "dark"];
const COLORS = { light: "#f7f4ee", dark: "#111916" };

const read = () => {
  try {
    const value = localStorage.getItem(KEY);
    return MODES.includes(value) ? value : "system";
  } catch {
    return "system";
  }
};

const write = (mode) => {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    return false;
  }
  return true;
};

export function createTheme(root = document.documentElement, media = window.matchMedia("(prefers-color-scheme: dark)")) {
  let mode = read();
  const listeners = new Set();
  const resolved = () => (mode === "system" ? (media.matches ? "dark" : "light") : mode);
  const apply = () => {
    const active = resolved();
    if (mode === "system") root.removeAttribute("data-theme");
    else root.dataset.theme = mode;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", COLORS[active]);
    listeners.forEach((listener) => listener(mode, active));
  };
  const onChange = () => {
    if (mode === "system") apply();
  };
  if (media.addEventListener) media.addEventListener("change", onChange);
  else if (media.addListener) media.addListener(onChange);
  apply();
  return {
    get mode() {
      return mode;
    },
    get active() {
      return resolved();
    },
    modes: MODES,
    set(next) {
      if (!MODES.includes(next)) return false;
      mode = next;
      write(mode);
      apply();
      return true;
    },
    subscribe(listener) {
      listeners.add(listener);
      listener(mode, resolved());
      return () => listeners.delete(listener);
    }
  };
}
